import { TranslateService } from '@ngx-translate/core';
import { ITableConfig } from '@widgets/innogy-data-table/tableDefinition/tableConfig.interface';
import {
  defaultSortColumn,
  defaultSortDirection,
} from '../components/receipt-overview/receipt-overview.component';
import { ReceiptType } from '../data/receipts.model';

export class ReceiptsTableConfig {
  public static getConfig(translate: TranslateService, type: ReceiptType): ITableConfig {
    return {
      tableSettings: {
        expandable: false,
        nextDataSelection: 'scroll',
        sortable: true,
        showEmptyResultsBanner: true,
        testId: 'receipts',
        defaultSort: {
          column: defaultSortColumn,
          direction: defaultSortDirection,
        },
      },
      columns: [
        {
          id: 'startTimestamp',
          value: translate.instant('EXPERT_VIEW_COLUMN.SESSIONSTART'),
          visibleInHeader: true,
          sortable: true,
          type: 'dateTime',
          width: '180px',
          adaptUserTimeZone: true,
        },
        ...(type === ReceiptType.PAYMENT_TERMINAL
          ? [
              {
                id: 'terminalId',
                value: translate.instant('TERMINAL_MANAGEMENT.TERMINAL_ID_SHORT'),
                visibleInHeader: true,
                sortable: true,
                type: 'text',
              },
            ]
          : []),
        {
          id: 'transactionId',
          value: translate.instant('TERMINAL_MANAGEMENT.TRANSACTION_ID'),
          visibleInHeader: true,
          sortable: true,
          type: 'text',
        },
        {
          id: 'cardType',
          value: translate.instant('TERMINAL_MANAGEMENT.CARD_TYPE'),
          visibleInHeader: true,
          sortable: true,
          type: 'text',
          width: '80px',
        },
        {
          id: 'cardNumberSuffix',
          value: translate.instant('TERMINAL_MANAGEMENT.CARD_NUMBER'),
          visibleInHeader: true,
          sortable: true,
          type: 'text',
        },
        ...(type === ReceiptType.DIRECT_PAYMENT
          ? [
              {
                id: 'email',
                value: translate.instant('GLOBAL.EMAIL_SHORT'),
                visibleInHeader: true,
                sortable: true,
                type: 'text',
                headerTooltip: translate.instant('RECEIPTS.EMAIL_HINT'),
              },
            ]
          : []),
        {
          id: 'totalAmount',
          value: translate.instant('TERMINAL_MANAGEMENT.TOTAL_PRICE'),
          visibleInHeader: true,
          sortable: true,
          type: 'text',
          width: '100px',
        },
        {
          id: 'chargepointId',
          value: translate.instant('CHARGING_STATION.CHARGE_PORT_ID'),
          visibleInHeader: true,
          sortable: true,
          type: 'link',
          shouldTextCrop: true,
        },
        {
          id: 'createdAt',
          value: translate.instant('TERMINAL_MANAGEMENT.RECEIPT_CREATION_TIME'),
          visibleInHeader: true,
          sortable: true,
          type: 'dateTime',
          width: '180px',
          adaptUserTimeZone: true,
        },
        {
          id: 'download',
          value: translate.instant('GLOBAL.DOWNLOAD'),
          visibleInHeader: true,
          sortable: false,
          type: 'dynamic',
        },
      ],
    };
  }
}
